import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';

export const timestampNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('timestamp'),
});
export type TimestampNodeCfgSchema = z.infer<typeof timestampNodeCfgSchema>;

export const timestampNodeSocketCfg = {
    controlSockets: {
        outputs: () => ({ next: 'event' }),
        inputs: () => ({ trigger: 'event' }),
    },
    dataSockets: {
        inputs: (_cfg: NodeCfg<'timestamp'>) => ({}),
        outputs: (_cfg: NodeCfg<'timestamp'>) => ({ epoch: 'number' }),
    },
} satisfies NodeSocketCfg<TimestampNodeCfgSchema>;
